import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { connect, Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import videojs from 'video.js';
import { _track } from '../../utils/track';
import 'video.js/dist/video-js.min.css';
import './index.scss';
let player = null,
	videoNode = null;
function Vh5Video(props) {
	let history = useHistory();
	let dispatch = useDispatch();
	let { closeCallback } = props;
	_track({
		trackName: 'toutu_idetail_page',
		payload: {
			...props.data,
			page_action_name: 'idetail-video'
		}
	});
	function handler(event) {
		// 根据event.orientation|screen.orientation.angle等于0|180、90|-90度来判断横竖屏
		// let value = event.orientation||window.screen.orientation.angle;
		// console.log (value);
		setTimeout(() => {
			if (document.body.clientWidth > document.body.clientHeight && player) {
				player.requestFullscreen && player.requestFullscreen();
			}
		}, 0);
	}
	useEffect(() => {
		player = videojs(videoNode, props, function onPlayerReady() {
			console.log('onPlayerReady', this);
		});
		player.on('dispose', function() {
			console.log('lience dispose');
		});
		player.on('pause', function() {
			console.log('lience pause');
		});
		player.on('ended', function() {
			console.log('lience ended');
		});
		// 监听 orientation changes
		window.addEventListener('orientationchange', handler);
		return () => {
			if (player) {
				player.dispose();
			}
			document.removeEventListener('mousedown', handler);
		};
	});
	function onClose() {
		if (player && player.dispose) {
			player.dispose();
		}
		return closeCallback && closeCallback();
	}
	return (
		<div className="vvideo">
			<i className="close" onClick={onClose}>
				&#xe652;
			</i>
			<div data-vjs-player>
				<video ref={node => (videoNode = node)} autoPlay={true} className="video-js"></video>
			</div>
		</div>
	);
}
export { Vh5Video };
